import { PublicKey } from '@solana/web3.js';
export default function validateSolAddress(address, hasToBeUser) {
    if (hasToBeUser === void 0) { hasToBeUser = true; }
    try {
        var pubkey = new PublicKey(address);
        if (!hasToBeUser) {
            return Boolean(pubkey);
        }
        var isSolana = PublicKey.isOnCurve(pubkey.toBuffer());
        return isSolana;
    }
    catch (error) {
        return false;
    }
}
